import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowLeft, Heart } from 'lucide-react';
import SinglesNightComponent from '@/components/SinglesNight';

const SinglesNightPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen" style={{ background: 'transparent' }}>
      {/* Header */}
      <header className="glass sticky top-0 z-50 border-b border-slate-700">
        <div className="container mx-auto px-4 py-3 flex items-center justify-between">
          <div className="flex items-center gap-4">
            <Button
              variant="ghost"
              size="sm"
              onClick={() => navigate('/home')}
              className="text-white hover:bg-white/10"
              data-testid="back-to-home-btn"
            >
              <ArrowLeft className="w-4 h-4 mr-2" />
              Back
            </Button>
            <div className="flex items-center gap-2">
              <div className="w-10 h-10 rounded-full bg-gradient-to-br from-pink-500 to-red-500 flex items-center justify-center">
                <Heart className="w-5 h-5 text-white" fill="white" />
              </div>
              <div>
                <h1 className="text-xl font-bold text-white">Singles Night</h1>
                <p className="text-xs text-slate-400">Weekly dating events at top bars</p>
              </div>
            </div>
          </div>
          <img 
            src="/nightbuzz-logo.png" 
            alt="NightBuZz" 
            className="h-10 rounded-lg cursor-pointer"
            onClick={() => navigate('/home')}
          />
        </div>
      </header>

      {/* Main Content */}
      <div className="container mx-auto px-4 py-8">
        <div className="max-w-2xl mx-auto">
          {/* Hero Section */}
          <div className="text-center mb-8">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-3" style={{ fontFamily: 'Space Grotesk' }}>
              Find Your Perfect Match
            </h2>
            <p className="text-slate-300">
              Every Saturday, the winning bar hosts NightBuZz's exclusive Singles Night. 
              Meet new people, enjoy drink specials, and make connections!
            </p>
          </div>

          {/* Singles Night Component */}
          <SinglesNightComponent />

          {/* Additional Info Cards */}
          <div className="grid md:grid-cols-2 gap-4 mt-8">
            <div className="glass p-4 rounded-lg border border-pink-500/20">
              <h3 className="font-semibold text-white mb-2 flex items-center gap-2">
                <span className="text-xl">👤</span> For Singles
              </h3>
              <ul className="text-sm text-slate-400 space-y-1">
                <li>• Free entry to all Singles Night events</li>
                <li>• Exclusive drink specials at host bars</li>
                <li>• Ice-breaker activities & games</li>
                <li>• Safe, fun environment to meet people</li>
              </ul>
            </div>
            
            <div className="glass p-4 rounded-lg border border-purple-500/20">
              <h3 className="font-semibold text-white mb-2 flex items-center gap-2">
                <span className="text-xl">🍸</span> For Bar Owners
              </h3>
              <ul className="text-sm text-slate-400 space-y-1">
                <li>• Bid to host Singles Night weekly</li>
                <li>• Massive foot traffic & revenue boost</li>
                <li>• Featured placement on NightBuZz app</li>
                <li>• Social media promotion included</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SinglesNightPage;
